import {Link} from 'gatsby';
import React from 'react';

import {createLangShortcut} from '../../../utils/createLangShortcut';
import {
  getCollectionListItemStyle,
  hasCollectionBackground,
} from '../../../utils/getCollectionBackground';
import {getCollectionMainTitleStyle} from '../../../utils/getH1Color';
import Carousel from '../../Carousel';
import './grid_large.css';
import './slice_collection_small.css';

const drawItem = (item) => {
  const linkedHero = item.correctSlice?.primary;
  const image = item.collection_image?.fluid?.src || linkedHero?.collection_image?.fluid?.src;
  const alt = item.collection_image?.alt;
  const title = item.collection_title || linkedHero?.hero_title.text;
  const localLink = item?.collection_link.uid;
  const externalLink = item.collection_link.raw.url;
  const linkLang = item.collection_link.lang;
  const bgVariant = item?.background_variant;
  const itemBgStyle = getCollectionListItemStyle(bgVariant);
  const hasItemBg = hasCollectionBackground(bgVariant);
  const text = item?.collection_description?.html;
  const filter = item.filter;
  const vimeoVideo = item?.vimeo_video?.embed_url;
  let segments = [];
  let videoId = '';
  if (vimeoVideo) {
    segments = vimeoVideo.split('/');
    videoId = segments[segments.length - 1];
  }

  return (
    <div
      className={hasItemBg ? 'bg-collection cardWrapperTall' : 'cardWrapperTall'}
      style={itemBgStyle}
      key={item.collection_title}
    >
      {localLink ? (
        <Link to={'/' + createLangShortcut(linkLang) + '/' + localLink}>
          <div className={text ? 'card' : 'card-nocontent'}>
            {title ? (
              <div className="itemtext">
                <h4 className="font-medium">{title}</h4>
                {text ? <div className="collection-text" dangerouslySetInnerHTML={{__html: text}}></div> : null}
              </div>
            ) : null}
            {image ? (
              <div className={`collection-img-wrapper ${filter ? 'myfilter' : ''}`}>
                <img src={image} alt={alt} />
              </div>
            ) : null}
            {vimeoVideo ? (
              <div className="vimeo-video-wrapper collection-vimeo">
                <iframe
                  title={title}
                  // eslint-disable-next-line max-len
                  src={`https://player.vimeo.com/video/${videoId}?speed=0&autoplay=1&controls=0&background=1&quality=720p&loop=1&muted=1}`}
                  width="640"
                  height="360"
                  frameBorder="0"
                  webkitallowfullscreen
                  mozallowfullscreen
                  allowFullScreen
                ></iframe>
              </div>
            ) : null}
          </div>
        </Link>
      ) : externalLink ? (
        <a href={externalLink} target="_blank" rel="noreferrer">
          <div className={text ? 'card' : 'card-nocontent'}>
            {title ? (
              <div className="itemtext">
                <h4 className="font-medium">{title}</h4>
                {text ? <div className="collection-text" dangerouslySetInnerHTML={{__html: text}}></div> : null}
              </div>
            ) : null}
            {image ? (
              <div className={`collection-img-wrapper ${filter ? 'myfilter' : ''}`}>
                <img src={image} alt={alt} />
              </div>
            ) : null}
            {vimeoVideo ? (
              <div className="vimeo-video-wrapper collection-vimeo">
                <iframe
                  title={title}
                  // eslint-disable-next-line max-len
                  src={`https://player.vimeo.com/video/${videoId}?speed=0&autoplay=1&controls=0&background=1&quality=720p&loop=1&muted=1}`}
                  width="640"
                  height="360"
                  frameBorder="0"
                  webkitallowfullscreen
                  mozallowfullscreen
                  allowFullScreen
                ></iframe>
              </div>
            ) : null}
          </div>
        </a>
      ) : (
        <div className={text ? 'card' : 'card-nocontent'}>
          {title ? (
            <div className="itemtext">
              <h4 className="font-medium">{title}</h4>
              {text ? <div className="collection-text" dangerouslySetInnerHTML={{__html: text}}></div> : null}
            </div>
          ) : null}
          {image ? (
            <div className={`collection-img-wrapper ${filter ? 'myfilter' : ''}`}>
              <img src={image} alt={alt} />
            </div>
          ) : null}
          {vimeoVideo ? (
            <div className="vimeo-video-wrapper collection-vimeo">
              <iframe
                title={title}
                // eslint-disable-next-line max-len
                src={`https://player.vimeo.com/video/${videoId}?speed=0&autoplay=1&controls=0&background=1&quality=720p&loop=1&muted=1}`}
                width="640"
                height="360"
                frameBorder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowFullScreen
              ></iframe>
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default function CollectionGridLarge(slice) {
  const listBgStyle = getCollectionListItemStyle(slice.primary.background_variant);
  const hasBg = hasCollectionBackground(slice.primary.background_variant);
  const carousel = slice.primary.mobil_karusell === true ? true : false;
  const collectiontitle = slice?.primary?.collection_main_title?.text;
  const mainTitleStyle = getCollectionMainTitleStyle(slice?.primary?.collection_main_title_color);
  const collectioningress = slice?.primary?.ingress?.text;

  return (
    <>
      <section
        className={`${
          hasBg ?
            slice?.source ?
              'bg-section tema large-grid-section ' :
              'bg-section content large-grid-section' :
            slice?.source ?
            'temaCollection large-grid-section' :
            'contentCollection large-grid-section'
        } ${carousel ? 'hidden-by-carousel ' : ' '}`}
        style={listBgStyle}
        key={Math.random()}
      >
        <div className="destination-grid-heading">
          {collectiontitle ? <h2 className="font-medium" style={mainTitleStyle}>{collectiontitle}</h2> : null}
          {collectioningress ? <p className="mx-auto">{collectioningress}</p> : null}
        </div>
        {getAlternatingRows(slice)}
      </section>
      <section
        className={`carousel-section ${
          hasBg ?
            slice?.source ?
              'bg-section tema large-grid-section ' :
              'bg-section content large-grid-section' :
            slice?.source ?
            'temaCollection large-grid-section' :
            'contentCollection large-grid-section'
        } ${carousel ? 'carousel-active ' : ' '}`}
        style={listBgStyle}
        key={Math.random()}
      >
        <div className="destination-grid-heading-mobile">
          {collectiontitle ? <h2 className="font-medium" style={mainTitleStyle}>{collectiontitle}</h2> : null}
          {collectioningress ? <p className="mx-auto">{collectioningress}</p> : null}
        </div>
        <Carousel>{getCarouselRows(slice)}</Carousel>
      </section>
    </>
  );
}

const getAlternatingRows = (slice) => {
  const gridHtml = [];

  for (let i = 0; i < slice.items.length; i += 2) {
    if (slice.items[i + 1]) {
      gridHtml.push(
          <div key={i} className="card-row">
            {drawItem(slice.items[i])}
            {drawItem(slice.items[i + 1])}
          </div>,
      );
    } else {
      gridHtml.push(
          <div key={i} className="card-row">
            {drawItem(slice.items[i])}
          </div>,
      );
    }
  }

  return gridHtml;
};

const getCarouselRows = (slice) => {
  const gridHtml = [];

  for (let i = 0; i < slice.items.length; i++) {
    gridHtml.push(
        <div key={i} className="card-row">
          {drawItem(slice.items[i])}
        </div>,
    );
  }

  return gridHtml;
};
